import { IconWrapper } from '../runtime';
export default IconWrapper('ap_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#9152FF"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 14H16C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14Z",
      "fill": "#7C3DEA"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 14H16C16 15.1046 15.1046 16 14 16H8V14Z",
      "fill": "#A470FF"
    }
  }), h("path", {
    "attrs": {
      "d": "M12 3V4.5L4 4.5V3H12Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M12 6V7.5L4 7.5V6L12 6Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M9 10.5V9L4 9V10.5H9Z",
      "fill": "white"
    }
  })]);
});